import { Component } from '@angular/core';
import { Field } from '@intersystems/isc-form';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'app-isc-form-field-hint-wrapper',
  templateUrl: './isc-form-field-hint-info.component.html',
  styleUrls: ['./isc-form-field-hint-info.component.scss'],
})
export class IscFormFieldHintInfoComponent extends FieldWrapper {
  field: Field;
}
